import { render, staticRenderFns } from "./caseSwiper.vue?vue&type=template&id=006f036c&scoped=true&"
import script from "./caseSwiper.vue?vue&type=script&lang=js&"
export * from "./caseSwiper.vue?vue&type=script&lang=js&"
import style0 from "./caseSwiper.vue?vue&type=style&index=0&id=006f036c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006f036c",
  null
  
)

export default component.exports